// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1kw6t","subheader":"ReorderModal_subheader__3LB-e","listWrap":"ReorderModal_listWrap__3dz-6"};